<h1 mat-dialog-title>{{ 'createSessionDialog.title' | translate }}</h1>
<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <div *ngIf="labRestriction">
    {{ 'createSessionDialog.labels.labRestrictionWarning' | translate }}
  </div>
  <div *ngIf="groups.length === 0 && !labRestriction ">
    {{ 'createSessionDialog.labels.noProjectsWarning' | translate }}
  </div>
  <form
    *ngIf="groups.length > 0 && !labRestriction"
    class="form-full-width"
    [formGroup]="form">
    <label [id]="getLabelId('project-select')">{{ 'common.labels.project' | translate }}<span class="red">*</span></label>
    <mat-form-field appearance="outline">
      <mat-select
        formControlName="projectSelect"
        [aria-labelledby]="getLabelId('project-select')"
        [placeholder]="'createSubjectDialog.labels.selectProject' | translate">
        <mat-optgroup *ngFor="let group of groups" [label]="group.label">
          <mat-option *ngFor="let project of group.projects" [value]="project._id">
            {{ project.label }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
      <mat-error *ngIf="form.get('projectSelect').hasError('required')">{{ 'createSessionDialog.labels.fieldRequired' | translate }}</mat-error>
    </mat-form-field>

    <label [id]="getLabelId('session-label')">{{ 'createSessionDialog.labels.sessionLabel' | translate }}<span class="red">*</span></label>
    <mat-form-field appearance="outline">
      <input
        matInput
        test-id="session-label"
        [id]="getLabelId('session-label')"
        [attr.aria-labelledby]="getLabelId('session-label')"
        [placeholder]="'createSessionDialog.labels.sessionLabel' | translate"
        type="text"
        formControlName="sessionLabel"
        autocomplete="off">
      <mat-error *ngIf="form.get('sessionLabel').hasError('maxlength')">{{ 'common.errors.maxLength' | translate }}</mat-error>
      <mat-error *ngIf="form.get('sessionLabel').hasError('minlength')">{{ 'common.errors.minLength' | translate }}</mat-error>
      <mat-error *ngIf="form.get('sessionLabel').hasError('required')">{{ 'createSessionDialog.labels.fieldRequired' | translate }}</mat-error>
    </mat-form-field>

    <label [id]="getLabelId('subject-label')">{{ 'createSessionDialog.labels.subjectLabel' | translate }}<span class="red">*</span></label>
    <mat-form-field appearance="outline">
      <input
        matInput
        test-id="subject-label"
        [attr.aria-labelledby]="getLabelId('subject-label')"
        [placeholder]="'createSessionDialog.labels.subjectLabel' | translate"
        type="text"
        formControlName="subjectLabel"
        autocomplete="off">
      <mat-error *ngIf="form.get('subjectLabel').hasError('maxlength')">{{ 'common.errors.maxLength' | translate }}</mat-error>
      <mat-error *ngIf="form.get('subjectLabel').hasError('minlength')">{{ 'common.errors.minLength' | translate }}</mat-error>
      <mat-error *ngIf="form.get('subjectLabel').hasError('required')">{{ 'createSessionDialog.labels.fieldRequired' | translate }}</mat-error>
    </mat-form-field>

    <label [id]="getLabelId('datepicker-label')">{{ 'common.labels.timestamp' | translate }}<span class="red">*</span></label>
    <fw-date-input
        min="1970-01-01T00:00"
        formControlName="dateTime"
        type="datetime-local">
    </fw-date-input>

    <label [id]="getLabelId('datepicker-label')">{{ 'common.labels.timezone' | translate }}</label>
    <app-typeahead
      class="timezone-typeahead full-width"
      [options]="timezoneOptions"
      [placeholder]="'common.labels.timezone' | translate"
      formControlName="timezone">
    </app-typeahead>
    <mat-error *ngIf="form.get('dateTime').hasError('required') || form.get('dateTime').hasError('required')">{{ 'createSessionDialog.labels.fieldRequired' | translate }}</mat-error>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-dialog-close mat-stroked-button test-id="close-button">{{ 'common.actions.close' | translate }}</button>
  <button mat-flat-button [disabled]="form.invalid" test-id="save-button"color="primary" (click)="submit()">
    {{ 'common.actions.save' | translate }}
  </button>
</div>
